import { BacklinkIndexer, BlockIndexer, SearchIndexer, } from '../../indexer/index.js';
import { addOnFactory } from './shared.js';
export const indexer = addOnFactory(originalClass => class extends originalClass {
    search(query) {
        return this.indexer.search.search(query);
    }
    constructor(storeOptions) {
        super(storeOptions);
        const blockIndexer = new BlockIndexer(this.doc, { slots: this.slots });
        this.indexer = {
            search: new SearchIndexer(this.doc),
            backlink: new BacklinkIndexer(blockIndexer),
        };
    }
});
//# sourceMappingURL=indexer.js.map